import { PDFFont, PDFPage, RGB } from "pdf-lib";

interface DrawTextCenterProps {
    page: PDFPage,
    text: string,
    font: PDFFont,
    size: number,
    y: number,
    color: RGB,
}

export const normalizeForPdf = (text: string): string => {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

export const scaleToFit = (originalWidth: number, originalHeight: number, maxWidth: number, maxHeight: number): { width: number, height: number } => {
    const widthRatio = maxWidth / originalWidth;
    const heightRatio = maxHeight / originalHeight;
    const scale = Math.min(widthRatio, heightRatio);
    return {
        width: originalWidth * scale,
        height: originalHeight * scale,
    };
};

export const drawTextCenter = ({
    page,
    text,
    font,
    size,
    y,
    color
}: DrawTextCenterProps) => {
    const { width } = page.getSize();
    const pdfFont = font as PDFFont;
    const textWidth = pdfFont.widthOfTextAtSize(text, size);
    const textX = (width - textWidth) / 2; // Center X
    page.drawText(text, { x: textX, y, size, font: pdfFont, color: color as RGB });
};

export const wrapText = (text: string, font: PDFFont, size: number, maxWidth: number): string[] => {
    const words = normalizeForPdf(text).split(' ');
    const lines: string[] = [];
    let line = '';

    for (const word of words) {
        const testLine = line ? `${line} ${word}` : word;
        const width = font.widthOfTextAtSize(testLine, size);
        if (width <= maxWidth) {
            line = testLine;
        } else {
            lines.push(line);
            line = word;
        }
    }
    if (line) lines.push(line);
    return lines;
};
